import classNames from "classnames";
import styles from "./PrimaryButton.module.scss";

export const PrimaryButton = ({ onClick, children, className, block, ...rest }) => (
  <button
    type="button"
    className={classNames(styles.root, { [styles.block]: block }, className)}
    onClick={onClick}
    {...rest}
  >
    {children}
  </button>
);
